export default __webpack_public_path__ + "static/media/dvameka-intro.cd7aad32.mp3";